<template>
  <div class="info-box-wrapper" v-if="visible">
    <div class="info-box-toggle" @click="closeBox">
      <font-awesome-icon icon="times"/>
    </div>
    <div class="info-box-content d-flex flex-column align-items-start">
      <div class="d-flex justify-content-center align-items-center mb-3">
        <font-awesome-icon class="mr-2" icon="desktop"/>
        <span>Frontend {{ frontendVersion }}{{ frontendCommit ? ` (${frontendCommit})` : '' }}</span>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <font-awesome-icon class="mr-2" icon="server"/>
        <span>Backend {{ backendVersion }}{{ backendCommit ? ` (${backendCommit})` : '' }}</span>
      </div>
    </div>
    <div class="info-box-text">
      For more information or technical support, contact us at +1 xxx.xxx.xxx
    </div>
    <div class="info-box-buttons">
      <a :href="'mailto:' + supportEmail">
        <!-- <button class="button blue-btn">
          EMAIL SUPPORT
        </button> -->
      </a>
      <button @click="closeBox" class="button blue-btn">
        CLOSE
      </button>
    </div>
  </div>
</template>

<script>
import http from '../../services/http'

export default {
  name: 'ApplicationInfoBox',
  data () {
    return {
      visible: false,
      frontendVersion: 'unknown',
      // Empty on a prod build (VUE_APP_COMMIT_SHA is only passed by the dev
      // CI workflow) - blank rather than 'unknown' so prod's info box doesn't
      // show a parenthetical that's never going to be filled in.
      frontendCommit: (process.env.VUE_APP_COMMIT_SHA || '').slice(0, 7),
      backendVersion: 'unknown',
      backendCommit: '',
      supportEmail: 'Currently Unavailable'
    }
  },
  created () {
    this.fetchFrontendVersion()
    this.fetchBackendVersion()
  },
  methods: {
    openBox () {
      this.visible = true
    },
    closeBox () {
      this.visible = false
    },
    // Static file shipped alongside the built SPA (frontend/public/VERSION),
    // written by the Dockerfile's VERSION build-arg at image build time -
    // see that ARG's comment for why this isn't release-please's extra-files
    // config (declared there originally, confirmed never to actually fire).
    // Fetched at runtime rather than inlined via a build-time env var, so a
    // stale browser tab asking a freshly-deployed server still gets the
    // right answer instead of whatever was baked in when it loaded.
    async fetchFrontendVersion () {
      try {
        const res = await fetch('/VERSION')
        this.frontendVersion = res.ok ? (await res.text()).trim() : 'unknown'
      } catch {
        this.frontendVersion = 'unknown'
      }
    },
    // /version is registered directly on the Flask app, not behind the
    // /api-prefixed blueprint the shared `http` client is scoped to (and
    // that client's own interceptor rejects absolute URLs outside its
    // baseURL anyway) - so this is a plain fetch against the API host with
    // that prefix stripped, not a call through `http`.
    async fetchBackendVersion () {
      try {
        const root = (http.defaults.baseURL || '').replace(/\/api\/?$/, '')
        const res = await fetch(`${root}/version`)
        const data = res.ok ? await res.json() : null
        this.backendVersion = data?.version || 'unknown'
        // 'unknown' from the backend itself (no GIT_COMMIT_SHA set, e.g. a
        // prod build) means nothing to show - same reasoning as frontendCommit.
        this.backendCommit = data?.commit && data.commit !== 'unknown' ? data.commit : ''
      } catch {
        this.backendVersion = 'unknown'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.info-box-wrapper {
  background: #FFFFFF;
  border: 2px solid #999999;
  border-radius: 6px;
  width: 680px;
  height: 312px;
  position: fixed;
  bottom: 96px;
  right: 87px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000 !important;

  .info-box-toggle {
    position: absolute;
    top: 28px;
    right: 32px;
    cursor: pointer;
  }

  .info-box-content {
    width: 568px;
    height: 80px;
    text-align: left;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    line-height: 20px;
    font-weight: 900;
    letter-spacing: 0;
  }

  .info-box-text {
    width: 568px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 13px;
    line-height: 23px;
    letter-spacing: 0;
  }

  .info-box-buttons {
    width: 568px;
    height: 80px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;

    .button {
      border-radius: 6px;
      width: 152px;
      height: 40px;
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 900;
      font-size: 11px;
      line-height: 20px;
      letter-spacing: 0;
    }

    .blue-btn {
      color: white;
      background: $blueberry 0 0 no-repeat padding-box;
      border: 1px solid #17469E;
      margin-left: 29px;

      transition: background-color 0.2s linear;
      &:hover {
        background-color: #9256D9;
      }
    }
  }
}
</style>
